import { useState } from "react";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { CustomButton } from "ui";
import { BID_REQUEST_STATUS_ENUM, BID_STATUSES, FILE_TYPE_ENUM, NOTIFICATION_TYPE_ENUM } from "interfaces";
import { acceptBidConditions } from "services";
import { useNotificationContext } from "providers";
import { parseErrorMessage } from "utils";

export const AcceptConditionsButton = observer(() => {
  const { bidCard } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const { id, documents } = bidCard.bid;

  const canAcceptBid = documents[FILE_TYPE_ENUM.AGENT_CONTRACT]
    ? documents[FILE_TYPE_ENUM.AGENT_CONTRACT_SIGNED]
    : true;

  const acceptConditionsHandler = async () => {
    setLoading(true);
    await acceptBidConditions({ id })
      .then(() => {
        openNotification({
          message: "Условия успешно приняты",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
        // setTimeout(() => {
        //   window.updateOnboardingElements?.();
        // }, 1500);
      })
      .catch((e) => {
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <CustomButton
      id="accept-conditions-button"
      onClick={acceptConditionsHandler}
      disabled={!canAcceptBid}
      loading={loading}
      tooltip={
        canAcceptBid
          ? `Заявка перейдет в статус: ${BID_STATUSES.texts[BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED]}`
          : "Загрузите документ: Агентский договор , подписанный"
      }
    >
      Принять условия
    </CustomButton>
  );
});
